var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"color-button",class:{ enabled: _vm.enabled },attrs:{"tabindex":_vm.enabled ? 0 : -1},on:{"click":_vm.onClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }